require('../modules/es6.parse-int');
module.exports = require('../modules/_core').parseInt;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/parse-int.js
// module id = 1206
// module chunks = 2